import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LessonCardContainer from '../components/LessonCard/LessonCardContainer';
import TrackCardContainer from '../containers/TracksPage/TrackCardContainer'; // @ts-expect-error Could not find a declaration file for module

import CatalogPageLayout from '../components/Layouts/CatalogPageLayout';
import UsageTracker from '../utils/UsageTracker';
import { RESULTS_URL_FRAGMENT } from '../constants/Navigation';
import { SCREENS } from '../constants/Tracking'; // @ts-expect-error Could not find a declaration file for module

import { getTracksAreRequesting } from '../selectors/trackSelectors'; // @ts-expect-error Could not find a declaration file for module

import { getLessonsAreRequesting } from '../selectors/lessonSelectors'; // @ts-expect-error Could not find a declaration file for module

import { useFetchFilters } from '../hooks/catalogPageHooks'; // @ts-expect-error Could not find a declaration file for module

import { useFetchTracksLessonsData } from '../hooks/catalogPageHooks';

const Catalog = () => {
  const dispatch = useDispatch();
  const isRequestingTracksOrLessons = useSelector(state => getTracksAreRequesting(state) || getLessonsAreRequesting(state));
  const hasError = useSelector(state => state.tracks.get('hasError'));
  const recentError = useSelector(state => state.tracks.get('recentError'));
  const {
    tracksLessonsSearchQueryData,
    tracksLessonsSearchQueryLoading,
    tracksLessonsSearchQueryError
  } = useFetchFilters();
  useFetchTracksLessonsData();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.TRACKS
    });
  }, [dispatch]);
  return /*#__PURE__*/_jsx(CatalogPageLayout, {
    catalogCards: tracksLessonsSearchQueryData.map(({
      id,
      contentType
    }, index) => contentType === 'TRACK' ? /*#__PURE__*/_jsx(TrackCardContainer, {
      appearsIn: "filterable-results",
      "data-test-id": `track-${id}`,
      position: index + 1,
      trackId: Number(id)
    }, id) : /*#__PURE__*/_jsx(LessonCardContainer, {
      appearsIn: "filterable-results",
      "data-test-id": `lesson-${id}`,
      lessonId: Number(id),
      position: index + 1
    }, `lesson-${id}`)),
    error: hasError ? recentError : tracksLessonsSearchQueryError,
    isRequestingCardsData: isRequestingTracksOrLessons || tracksLessonsSearchQueryLoading,
    pageUrlFragment: RESULTS_URL_FRAGMENT
  });
};

export default Catalog;